/* eslint-disable */
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { ListTable } from '@/Components/ListTable';
import { urls } from '@/Constants';

function WastageTable(props) {
	const {
		data = [], colMap = {}, special = {}, specialMappings = {}, tableType, filters = {}, location = {},
	} = props;
	console.log(filters, 'filters');
	const history = useHistory();
	const getTable = (type) => {
		switch (type) {
			case 'wastage':
				return (
					<ListTable
                    colMap={colMap}
					actions={special}
					special={specialMappings}
					data={data.map((obj,idx) => ({
							...obj,
							onClick: () => history.push({
								pathname: `${urls.EXTENSION}${urls.WASTAGE_LOG_DETAILS}`,
								search: `dateRange=${JSON.stringify(filters?.dateRange)}`,
								state: {
									data: obj,
									idx,
								},
							}),
					}))}
					allowExport={false}
					showBtnContainer={false}
					headerColor={true}
                    />
				);
            case 'transit':
                return (
					<ListTable
                    colMap={colMap}
					actions={special}
					special={specialMappings}
					data={data.map((obj,idx) => ({
						...obj,
						onClick: () => history.push({
							pathname: `${urls.EXTENSION}${urls.TRANSIT_LOG_DETAILS}`,
							search:  `dateRange=${JSON.stringify(filters?.dateRange)}`,
							state: {
								data: obj,
								idx,
							},
						}),
					}))}
					allowExport={false}
					showBtnContainer={false}
					headerColor={true}
                    />
				);
            case 'dispatchedItems':
                return (
                    <ListTable
                    colMap={colMap}
					actions={special}
					special={specialMappings}
					data={data}
					allowExport={false}
					showBtnContainer={false}
					headerColor={true}
                    />
                )
				case 'receivedItems':
					return (
						<ListTable
						colMap={colMap}
						actions={special}
						special={specialMappings}
						data={data}
						allowExport={false}
						showBtnContainer={false}
						headerColor={true}
						/>
					)
            case 'document':
                return (
                    <ListTable
                    colMap={colMap}
					actions={special}
					special={specialMappings}
					data={data}
					allowExport={false}
					showBtnContainer={false}
					headerColor={true}
                    />
                )
			default:
				return null;
		}
	};
	return getTable(tableType);
}
export default WastageTable;
